import type { OptionsDocument } from 'paintscout'
import type { EditableRate } from '../../options'
import type { UpdateableProduct } from './index'
import convertProductDetails from './util/convert-product-details'

export function getEditableRateUpdateableProducts({
  rate,
  options
}: {
  rate: EditableRate
  options: OptionsDocument
}): UpdateableProduct[] {
  const { rateType } = rate
  const legacyProduct = rate.defaultProduct ? { productKey: rate.defaultProduct, coverage: rate.coverage } : null
  const defaultProducts: { productKey: string; unitLabel?: string; coverage?: number }[] = [
    ...(legacyProduct ? [{ ...legacyProduct, coverage: Number(legacyProduct.coverage) }] : []),
    ...(rate?.defaultProducts ?? []).map((product) => ({
      ...product,
      coverage: Number(product.coverage)
    }))
  ]
  const updatedableProducts = defaultProducts.map((productDetails) => {
    return convertProductDetails({ productDetails, options, rateType })
  })

  return updatedableProducts
}
